// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles-m__slider__1Tv1B","slider-btn":"styles-m__slider-btn__2V_4C","urdu-line-height":"styles-m__urdu-line-height__2rbMv"};